import { createSelector } from 'reselect';
import { format, isValid, parseISO } from 'date-fns';

import { INews } from '../../types/developer/news';
import { IApplicationState } from '../../types/redux';

const emptyNews = Array.of<INews>();

const getFskNews = (state: IApplicationState) => state.fsk?.news;
const getDeveloperState = (state: IApplicationState) => state.developer;

export const getNews = createSelector([getFskNews, getDeveloperState], (fskNews, developer) => {
  if (fskNews) {
    return fskNews.map((item, index) => {
      const parsedDate = parseISO(item.date);

      return {
        id: index,
        title: item.text,
        date: isValid(parsedDate) ? format(parseISO(item.date), 'dd.MM.yy') : '',
      };
    });
  }

  if (!developer) {
    return emptyNews;
  }

  return developer.news;
});
